import React from "react";
import FilterForm from "../../common/FilterForm";

const Section1 = () =>  { 
	return <FilterForm/>;
};

export default Section1;